import { render, staticRenderFns } from "./albumList.vue?vue&type=template&id=0006fee9&scoped=true&"
import script from "./albumList.vue?vue&type=script&lang=ts&"
export * from "./albumList.vue?vue&type=script&lang=ts&"
import style0 from "./albumList.vue?vue&type=style&index=0&id=0006fee9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0006fee9",
  null
  
)

export default component.exports